import * as React from 'react'
import classNames from 'classnames'

export const feedbackTypesArray = [
  'success',
  'warning',
  'error',
  'info',
] as const
export type FeedbackType = typeof feedbackTypesArray[number]
export interface Props {
  /** one of "success", "warning", "error" or "info" to match pattern library */
  type?: FeedbackType
  children: React.ReactNode
  /** additional CSS classes to apply to the element */
  displayClasses?: string
  /** Optional identifier for the automated QA */
  dataSeleniumTarget?: string
}

const Feedback: React.FunctionComponent<Props> = ({
  type,
  children,
  displayClasses,
  dataSeleniumTarget,
  ...rest
}) => {
  return (
    <div
      className={classNames(
        'dm-feedback',
        type && `dm-feedback--${type}`,
        displayClasses
      )}
      data-selenium-target={dataSeleniumTarget}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Feedback
